export default __webpack_public_path__ + "static/media/header-deco.85284da1.webp";